export default {
	add: 'إضافة مسمى',

	positionSearch: 'المسمى',

	headers: {
		name: 'المسمى',
		chipNo: 'رقم الشريحة',
	},

	addPosition: {
		title: 'إضافة مسمى',
		name: 'اسم المسمى',
		chipNo: 'رقم الشريحة',
		jobParent: 'المسمى الأب',
	},
};
